

<div class="row">
 

    <div class="col-lg-3">
   
   
           
           </div>
   
   
   
           <div class="col-lg-6">
            
            <form #personalForm="ngForm" class="editForm" novalidate>
   
            <div class="card card-primary">
             <div class="card-header text-uppercase">
                 {{title}}
               </div>
              
   
               <div class="appliciant-img">
                  <img [src]="photoUrl" class="card-img-top" alt="Card image cap">

               </div>
             <div class="card-body">
   
             <div class="custom-file mt-0">
                <input type='file' accept=".jpg,.jpeg,.png" (change)="onSelectFile($event)" class="custom-file-input" id="customFile">
                    <label class="custom-file-label"  for="customFile">Choose Image</label>
              </div>
               <hr>
                <p class="card-text">Please upload your recent passport picture by clicking on the browse button provided above</p>
               <p class="card-text"> Note: Your picture must be of <mark> JPEG (Joint Photographic Experts Group) or (Graphics Interchange Format) </mark> file format with a file size <mark> not more than 65KB and a White Background</mark>. </p>
         <hr>
               <div class="text-center">
   
   
   
                  <button class="btn btn-default waves-effect waves-light m-1 float-left" (click)="goToPrevious()"><i class="fa fa-backward"></i> Go Back</button>
                  <button class="btn btn-primary waves-effect waves-light m-1 float-right" id="next" [disabled]="!personalForm.valid" (click)="goToNext()">Save &amp; Continue</button>
      
   
               </div>
             </div>
           </div>
         </form>
   
           </div>
          
   
           <div class="col-lg-3">
        
         </div>

